import { HttpService } from '@/data/http/http-service';
import { ImpactCo2AnswerStatsPublic } from '@/domain/impact-stats/entities/stats-public.entity';
import { ImpactStatsGateway } from '@/domain/impact-stats/gateways/impact-stats.gateway';

import { statsPublicDtoSchema } from './stats-public.dto';
import { StatsPublicMapper } from './stats-public.mapper';

export class ApiImpactStatsHttpGateway implements ImpactStatsGateway {
  private http = new HttpService({
    baseURL: import.meta.env.VITE_API_IMPACT,
  });

  async getStatsPublic(
    projectId: number,
    invitationCode: string,
  ): Promise<ImpactCo2AnswerStatsPublic> {
    const url = '/stats/public';
    const data = { projectId, userId: invitationCode };
    const response = await this.http.post(url, data);
    const result = statsPublicDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const statsPublic = StatsPublicMapper.dtoToEntity(result.data);
    return statsPublic;
  }
}
